import AddActionIcon from 'icons/AddActionIcon'
import * as Yup from 'yup'

export const toolbarActions = ({ canCreate, navigate, openModal }) => {
  const toolbar = []

  const createButton = {
    label: 'Add assignment',
    icon: <AddActionIcon />,
    onClick: () => openModal()
  }

  if (canCreate) {
    toolbar.push(createButton)
  }

  return toolbar
}

export const assignmentValidationSchema = Yup.object()
  .shape({
    jobTitle: Yup.string().required('Job Title is required'),
    startDate: Yup.date().required('Start Date is required'),
    endDate: Yup.date().nullable()
      .test(
        'is-after-start-date',
        'End Date must be after Start Date',
        function (value) {
          const startDate = this.parent.startDate;
          if (!value) return true;
          if (value > startDate) return true;
          return this.createError({
            path: 'endDate',
            message: 'End Date must be after Start Date'
          })
        }
      ),
    email: Yup.string().email('Invalid email format'),
    adAccount: Yup.boolean(),
    googleAccount: Yup.boolean(),
    ldapAccount: Yup.boolean(),
    manager: Yup.number().required('Manager is required')
  })
  .test('oneOfRequired', 'adAccount or googleAccount or ldapAccount is required', function (value) {
    const { adAccount, googleAccount, ldapAccount } = value
    if (!adAccount && !googleAccount && !ldapAccount) {
      return this.createError({
        path: 'googleAccount',
        message: 'AD Account or LDAP Account or Google Account is required'
      })
    }
    return true
  })
